var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmenidades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.999,
    height: 64.525,
    viewBox: "0 0 69.999 64.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7A4666;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Amenidades",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M86.117,263.455a1.368,1.368,0,1,0-.967-.4A1.368,1.368,0,0,0,86.117,263.455Z",
    transform: "translate(-73.813 -227.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M56.444,35.957a9.435,9.435,0,1,0,5.539-17.816,15.107,15.107,0,1,0-29.911-3.015c0,.488.023.978.071,1.465a12.1,12.1,0,0,0-7.456,17.077H17.772a1.368,1.368,0,0,0,0,2.735H33.631v6.015H2.735V36.4H6.84a1.368,1.368,0,0,0,0-2.735H1.367A1.367,1.367,0,0,0,0,35.034v8.75a1.367,1.367,0,0,0,1.367,1.367h4.1v4.9h-4.1A1.367,1.367,0,0,0,0,51.423v5.468a1.367,1.367,0,0,0,1.367,1.367h4.1v3.554h-4.1a1.368,1.368,0,0,0,0,2.735H61.248a1.368,1.368,0,0,0,0-2.735h-.141c.009-.146.014-.293.014-.44A7.823,7.823,0,0,0,48.546,55.15V41.711A10.324,10.324,0,0,0,56.444,35.957ZM27.876,33.667A9.36,9.36,0,0,1,33.9,18.99a1.365,1.365,0,0,0,1.115-1.6,12.371,12.371,0,1,1,23.923,1.6,1.367,1.367,0,0,0,1.354,1.791c.089,0,.181-.006.272-.006a6.7,6.7,0,1,1-4,12.073,1.367,1.367,0,0,0-2.132.725,7.555,7.555,0,0,1-5.885,5.374V29.925l6.786-6.786A1.369,1.369,0,1,0,53.4,21.2l-4.853,4.852V20.584a1.368,1.368,0,0,0-2.735,0v8.776h0V30.97l-5.291-5.3a1.369,1.369,0,0,0-1.936,1.936l7.147,7.147c.027.027.055.052.084.076v4.117a7.457,7.457,0,0,1-4.144-2.278,1.365,1.365,0,0,0-1.661-.258,9.365,9.365,0,0,1-3.641,1.123v-2.5A1.368,1.368,0,0,0,35,33.667ZM35,45.153a1.367,1.367,0,0,0,1.367-1.367v-3.51a12.148,12.148,0,0,0,4.048-1.025,10.314,10.314,0,0,0,5.4,2.452v14.4a7.129,7.129,0,0,0-6.159,5.7H30.9V58.258H35a1.367,1.367,0,0,0,1.367-1.367V51.423A1.367,1.367,0,0,0,35,50.055H30.9v-4.9Zm-26.8,0H28.162v4.9H8.2ZM2.735,52.789h30.9v2.733H2.735ZM8.2,58.258h19.96v3.554H8.2Zm40.945.146a5.1,5.1,0,0,1,9.239,2.968c0,.147-.006.294-.019.44h-15.9a4.388,4.388,0,0,1,5.233-2.881A1.365,1.365,0,0,0,49.148,58.4Z",
    transform: "translate(0 -0.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M356.339,109.16a1.365,1.365,0,1,0-.967-.4A1.365,1.365,0,0,0,356.339,109.16Z",
    transform: "translate(-309.161 -92.696)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenidades);
export default __webpack_public_path__ + "static/media/Amenidades.678b7ea24478742536ed3d37e3c2fca6.svg";
export { ForwardRef as ReactComponent };